import api from './apiClient';

export interface ReferralMe {
  code: string;
  register_url: string;
  referee_extra_trial_days: number;
  referrer_discount_percent: number;
  referrer_min_paid_months: number;
  referrals_completed: number;
  pending_referrer_rewards: number;
}

export interface ReferralValidate {
  valid: boolean;
  referrer_name?: string | null;
}

export const referralService = {
  getMine: async (): Promise<ReferralMe> => {
    const { data } = await api.get<ReferralMe>('/referrals/me');
    return data;
  },

  validateCode: async (code: string): Promise<ReferralValidate> => {
    const { data } = await api.get<ReferralValidate>(
      `/referrals/validate/${encodeURIComponent(code.trim())}`
    );
    return data;
  },
};
